<template>
  <div class="section-title section-title-internal">
    <div class="section-title-icon">
      <router-link to="/gestao-cadastros">
        <button><i class="icofont-reply"></i> <span>Voltar</span></button>
      </router-link>
    </div>
    <div class="section-title-info">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
    </div>
    <div class="section-title-btn-help">
      <modal-informacao :text="text"></modal-informacao>
    </div>
    <ModalAjuda
      v-if="showModalAjuda"
      @close-modal-ajuda="closeModalAjuda()"
      :card_title="title"
      :linkvideo="linkvideoajuda"
    >
    </ModalAjuda>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalAjuda from './ModalAjuda'
import ModalInformacao from '@/components/ModalInformacao.vue'
import { infoHtml } from './utils.js'

export default {
  name: 'SectionTitle',
  components: {
    ModalAjuda,
    ModalInformacao,
  },
  // computed: mapState(['modal_ajuda']),
  computed: {
    modal_ajuda() {
      if (this.$store.getters.getModalAjuda(this.title) == undefined) {
        return false
      }
      return this.$store.getters.getModalAjuda(this.title)
    },
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    linkvideoajuda: {
      type: String,
      default: '',
    },
  },
  mounted() {
    // this.exibirModalAjuda();
  },
  data() {
    return {
      showModalAjuda: null,
      title: 'Cidadão',
      description: 'Dados do cidadão (Imprimir cartão SUS, equipe e ACS)',
      text: infoHtml,
    }
  },
  methods: {
    exibirModalAjuda() {
      let modalAjudaStore = this.$store.getters.getModalAjuda('Cidadão')
      if (
        modalAjudaStore != undefined &&
        modalAjudaStore.active == false &&
        this.showModalAjuda != false
      ) {
        this.showModalAjuda = false
      } else {
        this.showModalAjuda = true
        let modal = {
          active: true,
          card: this.title,
        }
        this.$store.commit('setModalAjuda', modal)
      }
    },
    closeModalAjuda() {
      this.showModalAjuda = false
    },
  },
}
</script>

<style></style>
